import baseUrl from "./baseUrl";

export interface DashboardPatientsCount {
  count: number;
  lastmonthRegister: number;
  todayRegister: number;
  appointmentToday: number;
  appointmentTomorrow: number;
  cancelledToday: number;
  cancelledthismonth: number;
  waittingForConsultant: number;
  totalTreatments: number;
  lastmonthAppointment: number;
}

export interface UpcomingAppointment {
  date: string;
  startTime: string;
  type?: string;
  patientId?: {
    fullName: string;
    mobileNo: string;
  };
  bookPatientId?: {
    fullName: string;
    phoneNumber: string;
  };
  doctorId?: {
    firstName: string;
    lastName: string;
  };
}

export interface UpcomingAppointmentsResponse {
  data: UpcomingAppointment[];
  count: number;
}

export interface TreatmentPieChartResponse {
  data: { label: string; value: number; color?: string }[];
  treatmenttoday: { label: string; value: number; color?: string }[];
}

export interface PatientsChartItem {
  count: number;
  date?: string;
}

export interface PatientsChartResponse {
  count?: PatientsChartItem[];
  county?: PatientsChartItem[];
  appointment?: PatientsChartItem[];
  appointments?: PatientsChartItem[];
}

export interface DentistAppointment {
  firstName: string;
  lastName: string;
  count: number;
}

export function getPatientsCount(): Promise<DashboardPatientsCount> {
  return baseUrl
    .get<DashboardPatientsCount>("dashboard/findPatientsCount")
    .then((response) => response.data);
}

export function getUpcomingAppointments(
  page: number
): Promise<UpcomingAppointmentsResponse> {
  return baseUrl
    .get<UpcomingAppointmentsResponse>("dashboard/upcommingAppointment", {
      headers: { page },
    })
    .then((response) => response.data);
}

export function getTreatmentPieChart(): Promise<TreatmentPieChartResponse> {
  return baseUrl
    .get<TreatmentPieChartResponse>("client/dashboard/findTreatmentPieChart")
    .then((response) => response.data);
}

export function getPatientsChart(): Promise<PatientsChartResponse> {
  return baseUrl
    .get<PatientsChartResponse>("client/dashboard/findPatientsChart")
    .then((response) => response.data);
}

export function getDentistWiseAppointments(): Promise<DentistAppointment[]> {
  return baseUrl
    .get<{ result: DentistAppointment[] }>("dashboard/dentistWiseAppointments")
    .then((response) => response.data.result);
}
